
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@/integrations/supabase/types';

type Discipline = Tables<'disciplines'>;
type Pillar = Tables<'pillars'>;

export const useDisciplines = () => {
  return useQuery({
    queryKey: ['disciplines'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('disciplines')
        .select(`
          *,
          pillars(name, description)
        `)
        .order('name');

      if (error) throw error;
      return data;
    },
  });
};

export const usePillars = () => {
  return useQuery({
    queryKey: ['pillars'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('pillars')
        .select('*')
        .order('name');

      if (error) throw error;
      return data;
    },
  });
};

export const useDisciplineBySlug = (slug: string) => {
  return useQuery({
    queryKey: ['discipline', slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('disciplines')
        .select(`
          *,
          pillars(name, description)
        `)
        .eq('slug', slug)
        .single();

      if (error) throw error;
      return data;
    },
  });
};
